if (!customElements.get('show-eye-button')) {
  class ShowEyeButton extends HTMLElement {
    constructor() {
      super();
      this.passwordField = this.parentElement.querySelector('input[type="password"]');
      this.isShown = false;
      this.iconHidden = this.querySelector('[data-icon-hidden]');
      this.iconShown = this.querySelector('[data-icon-shown]');
    }

    connectedCallback() {
      this.addEventListener('click', () => this.toggleField());
      this.passwordField.addEventListener('input', () => this.toggleDisplay());
    }

    toggleDisplay() {
      this.passwordField.value == '' ? this.classList.remove('active') : this.classList.add('active');
    }

    toggleField() {
      this.passwordField.type = this.isShown ? 'password' : 'text';
      if (this.isShown) {
        this.iconShown.classList.remove('active');
        this.iconHidden.classList.add('active');
      } else {
        this.iconShown.classList.add('active');
        this.iconHidden.classList.remove('active');
      }
      this.isShown = !this.isShown;
    }
  }
  customElements.define('show-eye-button', ShowEyeButton);
}
